export const convertBankList = (bankList) => {
  let convertedBankList = [];

  if (!bankList) return [];

  bankList.forEach((bank) => {
    convertedBankList.push({
      value: bank.id,
      label: bank.bank_name,
    });
  });
  return convertedBankList;
};
